<template>
  <div v-loading="loading" class="profiles">
    <div class="filters-before-table">
      <search-input
        placeholder="Поиск по названию"
        style="width: 300px"
        v-model="filters.search"
        @change="filtersChanged"
      >
      </search-input>
      <el-switch
        style="margin-left: 20px"
        v-model="filters.only_active"
        :active-value="1"
        :inactive-value="0"
        active-text="Только активные"
        @change="filtersChanged"
      >
      </el-switch>
    </div>
    <div class="profile-block">
      <el-table
        :data="profiles"
        :show-header="!!profiles.length"
        empty-text="Нет созданных профилей"
      >
        <el-table-column prop="name" label="Название" width="500">
          <template v-slot="scope">
            <router-link
              class="table-router-link"
              :to="{ name: 'EvalProfile', params: { id: scope.row.id } }"
              target="_blank"
            >
              {{ scope.row.name }}
            </router-link>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="Описание"></el-table-column>
        <el-table-column width="90" prop="disabled" label="Активен">
          <template v-slot="scope">
            <span v-if="scope.row.disabled">Нет</span>
            <span v-else>Да</span>
          </template>
        </el-table-column>
        <el-table-column width="110" align="right" label="">
          <template v-slot="scope">
            <el-button
              class="table-action-button"
              style="margin-right: 10px"
              size="mini"
              round
              icon="fas fa-pen"
              @click="onEditProfile(scope.row)"
            >
            </el-button>
            <el-popconfirm
              confirm-button-text='Да'
              cancel-button-text='Нет'
              icon="el-icon-question"
              title="Вы уверены, что хотите удалить профиль?"
              @confirm="deleteProfile(scope.row)"
            >
              <el-button
                slot="reference"
                class="table-action-button"
                size="mini"
                round
                icon="far fa-trash-alt"
              >
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <paginator
      :paginator.sync="paginator"
      use-router-query-param
      @page-changed="loadProfiles"
    ></paginator>
  </div>
</template>

<script>
import Paginator from "@/components/Paginator";
import SearchInput from "@/components/filters/SearchInput.vue";
import {paginator} from "@/mixins/paginator";

export default {
  name: "profiles-component",
  components: {Paginator, SearchInput},
  mixins: [paginator],
  props: {
    onEditProfile: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      profiles: [],
      filters: {},
    }
  },
  beforeMount() {
    this.paginator.perPage = 10;
  },
  mounted() {
    this.loadProfiles();
  },
  methods: {
    loadProfiles() {
      this.loading = true;
      this.$api.evaluation.profileSearch({
        ...this.filters,
        [this.paginator.param]: this.paginator.page,
        [this.paginator.paramPerPage]: this.paginator.perPage,
      })
        .then(({data, paginator}) => {
          this.profiles = data.profiles;
          this.paginatorFill(paginator);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    deleteProfile(profile) {
      this.loading = true;
      this.$api.evaluation.profileDelete({
        ids: [profile.id]
      })
        .then(data => {
          this.$notify.success({
            title: 'Удалено',
            message: 'Профиль успешно удален'
          });
        })
        .finally(() => {
          this.loadProfiles();
        })
    },
    filtersChanged() {
      this.loadProfiles();
    }
  }
}
</script>

<style scoped lang="scss">
  .profiles {
    .profile-block {
      margin: 25px 0;
    }

    .table-router-link {
      text-decoration: none;
    }
  }
</style>